<template>
  <div>
    <div>
      <label for="group" class="block text-sm font-medium leading-6 text-gray-900">Group</label>
      <v-select
          class="bg-white rounded py-1"
          v-model="eventShowType.group_type"
          :options="eventShowTypeGroups"
          :clearable="false"
        >
        </v-select>
    </div>
    <div>
      <label for="class_list" class="block text-sm font-medium leading-6 text-gray-900">Class List</label>
      <v-select
          class="bg-white rounded py-1"
          v-model="eventShowType.class_list_id"
          :options="adminData.class_configurations"
          label="identifier"
          :reduce="option => option.class_configuration_id"
          :clearable="false"
        >
        </v-select>
    </div>
    <div>
      <label for="class_list" class="block text-sm font-medium leading-6 text-gray-900">Status</label>
      <v-select
          class="bg-white rounded py-1"
          v-model="eventShowType.status"
          :options="statusOptions"
          label="label"
          :reduce="option => option.value"
          :clearable="false"
        >
        </v-select>
    </div>
    <entry-field-config-builder v-model="eventShowType.entry_details"/>
    <button @click="saveEventShowType" type="button" class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Save entry type</button>
  </div>
</template>
<script>
import EntryFieldConfigBuilder from '@/components/admin/EntryFieldConfigBuilder.vue'
export default {
  components: {
    EntryFieldConfigBuilder
  },
  props: {
    eventShowType: Object
  },
  data () {
    return {
      statusOptions: [
        {label: 'Admin Only', value: 'ADMIN'},
        {label: 'Active', value: null}
      ]
    }
  },
  methods: {
    saveEventShowType: function () {
      this.eventShowType.name = 'event_show_types'

      if (!this.eventShowType.event_show_type_id) {
        this.$store.dispatch('addData', this.eventShowType)
          .then(response => {
            this.notie.alert({
              type: 1,
              text: `Entry Type Successfully Saved`
            })
            this.$emit('saved')
          })
          .catch(() => {
            // this.$honeybadger.notify(error)
            this.notie.alert({
              type: 3,
              text: `Error creating Entry Type, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
            })
          })
      } else {
        this.$store.dispatch('updateData', this.eventShowType)
          .then(response => {
            this.notie.alert({
              type: 1,
              text: `Entry Type Updated`
            })
            this.$emit('saved')
          })
          .catch(() => {
            // console.log(error)
            // this.$honeybadger.notify(error)
            this.notie.alert({
              type: 3,
              text: `Error Updating Entry Type, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
            })
          })
      }
    }
  },
  computed: {
    adminData () {
      return this.$store.state.admin.adminData
    },
    event_show_type_schema () {
      let schema = [
        {
          label: 'Entry Type',
          model: this.eventShowType,
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Label',
              model: 'label',
              placeholder: 'Type Label',
              required: true,
              hint: 'This is the label exhibtiors will see when selecting/making an entry of this type.'
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Group',
              model: 'group_type',
              placeholder: 'Group',
              required: true,
              hint: 'This is the GROUP that the entry type will be listed underneath. Try to group similar entry Types together. Either by SPECIES or SHOW type.'
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Status',
              model: 'status',
              placeholder: 'Group',
              required: false,
              hint: 'Set to ADMIN to make it admin only.'
            }
          ]
        }
      ]
      if (!this.adminData.event.event_settings.dynamic_class_lists) {
        schema.push({
          type: 'input',
          inputType: 'text',
          label: 'Class List ID',
          model: 'class_list_id',
          required: true,
          hint: 'THIS WILL BE MOVED OUT SOON...OR MAKE ADMIN ONLY???'
        })
      }
      return schema
    },
    json_edit_field () {
      return [
        {
          label: 'Entry Type',
          model: this.eventShowType,
          fields: [
            {
              type: 'json',
              label: 'Entry Details',
              model: 'entry_details'
            },
            {
              type: 'json',
              label: 'Class Cals',
              model: 'class_calc'
            },
            {
              type: 'json',
              label: 'Entry Sections',
              model: 'entry_sections'
            }
          ]
        }
      ]
    },
    eventShowTypeGroups () {
      let groups = []
      this.adminData.event_show_types.forEach(et => {
        if (!groups.includes(et.group_type)) {
          groups.push(et.group_type)
        }
      })
      return groups
    }
  }
}
</script>

<style>

</style>
